import React from 'react';

import { AlertTitle, Alert, Collapse } from '@mui/material';
import _ from 'lodash';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import { ClassContainer } from './ClassContainer';

type ValidationError = {
    message: string;
    type: string;
    ref: { [key: string]: any };
};

type DateErrors = {
    days: ValidationError;
    dateRange: ValidationError;
};

type ErrorObject = {
    [key: string]: FieldError | DateErrors[] | ErrorObject | any;
};

const extractErrorMessages = (errorsObj: ErrorObject) => {
    const errorMessages: string[] = [];

    _.forEach(errorsObj, (error: any) => {
        if (error?.message) {
            errorMessages.push(error.message);
        } else {
            errorMessages.push(...extractErrorMessages(error));
        }
    });

    return errorMessages;
};

export interface ClassModalErrorsProps {}

const ClassFormErrors: React.FC<ClassModalErrorsProps> = () => {
    const { t } = useTranslation('common');

    const { errorMessage, formErrors, setErrorMessage } = useContainer(ClassContainer);
    const extractedFormErrors = extractErrorMessages(formErrors);

    return (
        <>
            <Collapse in={!!errorMessage}>
                <Alert severity="error" onClose={() => setErrorMessage('')}>
                    {errorMessage}
                </Alert>
            </Collapse>
            <Collapse in={!!extractedFormErrors.length}>
                <Alert severity="error">
                    <AlertTitle>{t('addressTheIssues')}</AlertTitle>
                    <ul style={{ paddingInlineStart: 0 }}>
                        {extractedFormErrors.map((error: string, i: number) => (
                            <li key={i}>{error}</li>
                        ))}
                    </ul>
                </Alert>
            </Collapse>
        </>
    );
};

export default ClassFormErrors;
